/**
 * ч.1034: за який період фіксувати акт звірки на «Монітор розрахунків».
 *
 * Правило: період акта = період, за який користувач БАЧИТЬ цифри.
 *  • «Загалом» (кнопка у попапі рядка) — таблицю побудовано кнопкою
 *    «сформувати», тож цифри рядка — за СФОРМОВАНИЙ період (`applied`),
 *    навіть якщо поля «З/По» після цього змінили.
 *  • «По контрагенту» — звіт перебудовується одразу за полями «З/По», тож
 *    період — поточні поля. Раніше тут брався сформований період
 *    «Загалом», якщо він був: сформували «Загалом» за 2025, перейшли «По
 *    контрагенту», змінили дати на 2026 — бачили 2026, а акт фіксувався
 *    за 2025.
 * Порожня дата = «за весь час»: початок — 1990-01-01, кінець — сьогодні.
 */
export interface PeriodFields { from: string; to: string }

export function actPeriod(
  fromSummaryTable: boolean,
  applied: PeriodFields | null,
  fields: PeriodFields,
  today: string,
): { period_start: string; period_end: string } {
  const p = fromSummaryTable && applied ? applied : fields;
  return {
    period_start: p.from || '1990-01-01',
    period_end: p.to || today,
  };
}
